import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class ProductInfoLinkResource extends BaseCamelCasedResource {
    pk() {
        return `${this.linkId}`;
    }
}
ProductInfoLinkResource.urlRoot = legacyApiResourceUrl("Product/GetAllProductInfoLinksForUser");
export { ProductInfoLinkResource };
//# sourceMappingURL=ProductInfoLinkResource.js.map